import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=5956827d"
import script from "./newsCenter.vue?vue&type=script&lang=js"
export * from "./newsCenter.vue?vue&type=script&lang=js"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=5956827d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports